// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__GTtic","productName":"Table_productName__27Tzs"};